import React, { useCallback } from 'react';

import Chip from '@material-ui/core/Chip';
import IconButton from '@material-ui/core/IconButton';
import FilterIcon from '@material-ui/icons/FilterList';

import './kits.scss';

const KitFiltersList = (props) => {
  const {
    onClick,
    activeTab = 0,
    hideShipped,
    hideConsignment,
    hideLoan,
    hideClosed,
    surgeons = [],
    hospitals = [],
    states = [],
    surgeonsList = [],
    hospitalsList = [],
    onDelete,
    showCanceled,
    isShipping
  } = props;

  const getSurgeonName = useCallback((surgeonId) => {
    const surgeon = surgeonsList.find((surgeon) => surgeon.id === surgeonId);
    return surgeon ? `${surgeon.title} ${surgeon.firstName} ${surgeon.lastName}` : '';
  }, [surgeonsList]);

  const getHospitalName = useCallback((hospitalId) => {
    const hospital = hospitalsList.find((hospital) => hospital.id === hospitalId);
    return hospital ? hospital.name : '';
  }, [hospitalsList]);

  return (
    <div className='kit-filters-list__container'>
      <IconButton onClick={onClick}>
        <FilterIcon />
      </IconButton>

      {hideShipped && activeTab === 1 && (
        <Chip label='Hide All Shipped' onDelete={() => onDelete('shipped')} />
      )}

      {/*{hideReturned && activeTab === 1 && (*/}
      {/*  <div className='kit-filters-list__item'>*/}
      {/*    Hide All Returned*/}
      {/*  </div>*/}
      {/*)}*/}

      {hideConsignment && (
        <Chip label='Hide Consignment' onDelete={() => onDelete('consignment')} />
      )}

      {hideLoan && (
        <Chip label='Hide Loan' onDelete={() => onDelete('loan')} />
      )}

      {!isShipping && (
        <>
          {hideClosed && (
            <Chip label='Hide Closed' onDelete={() => onDelete('closed')} />
          )}

          {showCanceled && (
            <Chip label='Show Canceled' onDelete={() => onDelete('canceled')} />
          )}
        </>
      )}

      {!!surgeons?.length && (
        surgeons.map((surgeon) => (
          <Chip label={getSurgeonName(surgeon)} onDelete={() => onDelete('surgeon', surgeon)} />
        ))
      )}

      {!!hospitals?.length && (
        hospitals.map((hospital) => (
          <Chip label={getHospitalName(hospital)} onDelete={() => onDelete('hospital', hospital)} />
        ))
      )}

      {!!states?.length && (
        states.map((state) => (
          <Chip label={state} onDelete={() => onDelete('state', state)} />
        ))
      )}
    </div>
  );
};

export default KitFiltersList;
